import React, { Component, Fragment } from 'react';
import Decorator from '../../../functions/decorator';

export default class AddOnCard extends Component {

    constructor(props) {
        super(props);
        this.onlyAddIfUnselected = this.onlyAddIfUnselected.bind(this);
        this.increaseQuantity = this.increaseQuantity.bind(this);
        this.decreaseQuantity = this.decreaseQuantity.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.generateJSXForList = this.generateJSXForList.bind(this);
        this.generateJSXForRadio = this.generateJSXForRadio.bind(this);
    }

    onlyAddIfUnselected() {
        if(!this.props.isSelected) {
            this.props.chooseAddOnItem(this.props.id, 1, this.props.price);
        }
    }

    increaseQuantity() {
        this.props.increaseAddOnQuantity(this.props.id);
    }


    decreaseQuantity() {
        if(this.props.quantity > 1) {
            this.props.decreaseAddOnQuantity(this.props.id);
        }else {
            this.props.removeItem(this.props.id);
        }
    }

    removeItem() {
        this.props.removeItem(this.props.id);
    }

    generateJSXForRadio() {
        let selectionColor = this.props.isSelected ? 'primary' : 'accent';
        return (
            <div className="d-flex flex-justify-left flex-align-center m-5 p-2">
                <div className='d-flex flex-justify-center flex-align-center flex-column mt-2'>
                    <h6>{this.props.name + ' '}
                    {this.props.isSelected ? (
                    <small>{Decorator.formatCurrency(this.props.price * this.props.quantity)}</small>) : (
                    <small>{Decorator.formatCurrency(this.props.price)} {this.props.isSelected ? this.props.name : ''}</small>)}
                    </h6>
                    {this.props.isSelected ? (
                        <Fragment>
                        <div className='d-flex flex-justify-center flex-align-center flex-wrap'>
                            <span onClick={this.decreaseQuantity} className={`clickable-element mif-minus mif-lg store-fg-${selectionColor}`}></span>
                            <p className={`text-center m-2 store-fg-${selectionColor}`}>{this.props.quantity}</p>
                            <span onClick={this.increaseQuantity} className={`clickable-element mif-plus mif-lg store-fg-${selectionColor}`}></span>
                        </div>
                        <button onClick={this.removeItem} className="button small accent mt-2">Remove</button>
                        </Fragment>
                    ) : (
                        <button onClick={this.onlyAddIfUnselected} className={`mt-2 btn btn-primary`}>Add</button>
                    )}
                </div>
            </div>
        );
    }

    generateJSXForList() {
        let selectionColor = this.props.isSelected ? 'primary' : 'accent';
        return (
            <div>
                <div className="card mb-1">
                    <div className="card-body">
                        <div className={"row"}>
                            <div className={!this.props.isSelected ? `col-9` : `col-4`}>
                                <h6>{this.props.name}</h6>
                                {Decorator.formatCurrency(this.props.price * (this.props.quantity ? this.props.quantity : 1))}
                            </div>
                            <div className={!this.props.isSelected ? `col-3` : `col-6`}>
                                {this.props.isSelected ?
                                    <div className='btn-group'>
                                        <button onClick={this.decreaseQuantity} className={`btn btn-${selectionColor}`}>-
                                        </button>
                                        <button className='btn btn-default disabled'>{this.props.quantity}</button>
                                        <button onClick={this.increaseQuantity} className={`btn btn-${selectionColor}`}>+
                                        </button>
                                    </div>
                                    :
                                    <button onClick={this.onlyAddIfUnselected} className={"btn btn-md mr-1 btn-primary"}>Add</button>
                                }
                            </div>
                            <div className={this.props.isSelected ? `col-2` : ``} hidden={!this.props.isSelected}>
                                <i onClick={this.removeItem} className={"fa fa-trash text-branded"}></i><br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    
    render() {
        return this.props.isRadio ? this.generateJSXForRadio() : this.generateJSXForList();
    }
}
